/** @jsxImportSource @emotion/react */

import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import HUI from "@henge-inc/ui/v1_2";
import HENGE from "@henge-inc/global-types";
import { AnimatePresence, motion } from "motion/react";
import { useScreenStore } from "@/stores/useScreenStore";

export const VaultFeedTitle = () => {
  const isMobileScreen = useScreenStore((state) => state.isMobileScreen);

  const [theVaultOfSomething, setTheVaultOfSomething] = useState("Creators");

  useEffect(() => {
    const interval = setInterval(() => {
      setTheVaultOfSomething((prev) => {
        switch (prev) {
          case "Creators":
            return "Makers";
          case "Makers":
            return "Designers";
          case "Designers":
            return "Builders";
          case "Builders":
            return "Studios";
          case "Studios":
            return "Archives";
          case "Archives":
            return "Creators";
          default:
            return "Creators";
        }
      });
    }, 1500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <motion.div
      className={"relative flex flex-row flex-wrap justify-center items-center"}
      style={{
        gap: isMobileScreen ? "12px" : "24px",
        marginBottom: "min(25vw, 25vh)",
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.5 }}
    >
      <div
        className={"select-none relative flex-grow-0 px-12 py-6 rounded-xl"}
        css={css`
          padding: clamp(8px, 2vw, 18px) clamp(16px, 4vw, 36px);
        `}
      >
        <HUI.Text
          kind={HENGE.TEXT_KIND.heading1}
          weight={HENGE.TEXT_WEIGHT.semibold}
          align={HENGE.TEXT_ALIGN.left}
          lineHeight={HENGE.TEXT_LINE_HEIGHT.small}
          whiteSpace={HENGE.TEXT_WHITE_SPACE.nowrap}
          css={css`
            & {
              height: clamp(40px, 10vw, 80px);
              font-size: clamp(32px, 8vw, 72px);
              color: var(--gray-10);

              & > span {
                display: inline-block;
                width: clamp(144px, 36vw, 324px);
                font-size: clamp(32px, 8vw, 72px);
              }
              & > span > span {
                display: inline-block;
                font-size: clamp(32px, 8vw, 72px);
                color: var(--gray-12);
              }
            }
          `}
        >
          The vault of{" "}
          <span className={"relative transition-all"}>
            <AnimatePresence mode="wait">
              <motion.span
                key={theVaultOfSomething}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.35, ease: "easeInOut" }}
                className="whitespace-nowrap"
              >
                {theVaultOfSomething}
              </motion.span>
            </AnimatePresence>
          </span>
        </HUI.Text>
      </div>
    </motion.div>
  );
};
